// Split a fill_blank statement on the FIRST `___` run (3+ underscores).
// 0 gaps → the whole string is `before`, `hasGap: false`; >1 gaps → only the
// first is a slot. Порт плеерного `FillBlankBlock/splitBlank.ts`, включая
// третье поле: `hasGap` говорит потребителю, рисовать ли пилюлю слота вовсе —
// без него утверждение без «___» (или вовсе пустое в прохождении) получало бы
// одинокую пилюлю-заглушку «…», которой у ученика никогда не будет.
export const splitFillBlank = (
  question: string,
): { before: string; after: string; hasGap: boolean } => {
  const m = question.match(/_{3,}/)
  if (!m || m.index === undefined) return { before: question, after: '', hasGap: false }
  return {
    before: question.slice(0, m.index),
    after: question.slice(m.index + m[0].length),
    hasGap: true,
  }
}
